import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { Action } from '@ngrx/store';
import { createActionType } from '../store.utils';

export const SNACKBAR_OPEN = createActionType('SNACKBAR_OPEN');
export const SNACKBAR_CLOSE = createActionType('SNACKBAR_CLOSE');

export class SnackbarOpen implements Action {
  readonly type = SNACKBAR_OPEN;

  constructor(
    public payload: {
      message: string;
      action?: string;
      config?: MatSnackBarConfig;
    }
  ) {
    if (!payload.config) {
      payload.config = this.defaultSnackbarConfig;
      payload.action = 'Fechar';
    }
  }

  get defaultSnackbarConfig(): MatSnackBarConfig {
    return {
      horizontalPosition: 'left',
      verticalPosition: 'top',
      panelClass: ['default'],
    };
  }
}

export class SnackbarClose implements Action {
  readonly type = SNACKBAR_CLOSE;
}

export type SnackbarAction = SnackbarOpen | SnackbarClose;
